import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #F5F5F5;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  color: #333;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 20px;
`;

export const FacilityImageSection = styled.div`
  width: 100%;
  height: 200px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.02);
  }

  &:hover::after {
    content: '시설 정보 보기';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const FacilityImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FacilityImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

export const InfoCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: left;
`;

export const FacilityNameRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const FacilityName = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0;
`;

export const ViewDetailLink = styled.button`
  background: transparent;
  border: none;
  color: #1FBC70;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;

  &:hover {
    background: #F0FFF7;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const LocationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const LocationIcon = styled.span`
  font-size: 16px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #E5E5E5;
  margin: 20px 0;
`;

export const InfoSection = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #999;
  margin-bottom: 8px;
`;

export const InfoValue = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const TimeDivider = styled.span`
  color: #999;
  font-weight: 400;
`;

export const StatusBadge = styled.div<{ status: string }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: ${props => {
    switch (props.status) {
      case 'upcoming': return '#E8F5E9';
      case 'completed': return '#F5F5F5';
      case 'cancelled': return '#FFEBEE';
      default: return '#E8F5E9';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'upcoming': return '#1FBC70';
      case 'completed': return '#999';
      case 'cancelled': return '#F44336';
      default: return '#1FBC70';
    }
  }};
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #F5F5F5;

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.div`
  font-size: 14px;
  color: #666;
`;

export const DetailValue = styled.div`
  font-size: 15px;
  color: #333;
  font-weight: 500;
`;

export const MemberInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
`;

export const MemberImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;

export const MemberDetails = styled.div`
  flex: 1;
`;

export const MemberName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
`;

export const MemberId = styled.div`
  font-size: 13px;
  color: #999;
`;

export const ButtonGroup = styled.div`
  padding: 0 20px 20px 20px;
  display: flex;
  gap: 12px;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 16px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.variant === 'primary' ? `
    background: #1FBC70;
    color: white;

    &:hover {
      background: #1AAA64;
    }
  ` : `
    background: white;
    color: #333;
    border: 2px solid #E5E5E5;

    &:hover {
      border-color: #1FBC70;
      color: #1FBC70;
    }
  `}

  &:active {
    transform: scale(0.98);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: #999;
  font-size: 14px;
`;

export const ErrorMessage = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #F44336;
  font-size: 14px;
`;

export const DescriptionSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: left;
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
  text-align: left;
`;

export const SectionContent = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
  text-align: left;
`;

export const IconText = styled.span`
  font-size: 18px;
  margin-right: 6px;
`;
